import { useLocation } from 'react-router-dom';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';

// @ts-expect-error Library not yet migrated

import ProfessorRow from '../ProfessorRow';
// @ts-expect-error Library not yet migrated
import { getSelectedLanguageFiltersFromRoute } from '../../selectors/routeSelectors';
import { getProfessorDescription } from '../../utils/ContentUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ProfessorList = ({
  professors,
  i18nHeading,
  handleOrganisationUrlClick,
  isAccordion = false
}) => {
  const location = useLocation();
  const languages = getSelectedLanguageFiltersFromRoute({}, {
    location
  });
  return isAccordion ? /*#__PURE__*/_jsx(AccordionItem, {
    size: "md",
    title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: i18nHeading,
      options: {
        count: professors.length
      }
    }),
    children: professors.map(professor => /*#__PURE__*/_jsx(View, {
      marginBlockStart: "900",
      children: /*#__PURE__*/_jsx(ProfessorRow, {
        description: getProfessorDescription(professor, languages.first()),
        handleOrganisationUrlClick: handleOrganisationUrlClick,
        id: professor.get('id'),
        image: professor.get('image'),
        jobTitle: professor.get('jobTitle'),
        linkedinUrl: professor.get('linkedinUrl'),
        name: professor.get('name'),
        organisation: professor.get('organisation'),
        organisationUrl: professor.get('organisationUrl'),
        xUrl: professor.get('twitterUrl')
      })
    }, professor.get('id')))
  }) : /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h4",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: i18nHeading,
        options: {
          count: professors.length
        }
      })
    }), professors.map(professor => /*#__PURE__*/_jsx(View, {
      marginBlockStart: "900",
      children: /*#__PURE__*/_jsx(ProfessorRow, {
        description: getProfessorDescription(professor, languages.first()),
        handleOrganisationUrlClick: handleOrganisationUrlClick,
        id: professor.get('id'),
        image: professor.get('image'),
        jobTitle: professor.get('jobTitle'),
        linkedinUrl: professor.get('linkedinUrl'),
        name: professor.get('name'),
        organisation: professor.get('organisation'),
        organisationUrl: professor.get('organisationUrl'),
        xUrl: professor.get('twitterUrl')
      })
    }, professor.get('id')))]
  });
};
export default ProfessorList;